import { ICaseCloseRepository } from '../ports/outbound/ICaseCloseRepository';
import { CaseClosureReason } from '../domain/entities/CaseClosureReason';

export class FetchCaseClosureReasonsUseCase {
    constructor(
        private readonly caseCloseRepository: ICaseCloseRepository
    ) { }

    async execute(everifyCaseId: string): Promise<CaseClosureReason[]> {
        return this.caseCloseRepository.fetchCaseClosureReasons(everifyCaseId);
    }
}
